import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Home'
import Features from '@/pages/features/Features'
import Educator from '@/pages/educator/Educator'
import Curriculum from '@/pages/curriculum/Curriculum'
import Help from '@/pages/help/Help'
import Redirect from '@/pages/Redirect'
import NotFound from '@/pages/NotFound'
import HelpApp from '@/pages/help/AppView'
import Signin from '@/pages/account/Signin'
import SigninEmail from '@/pages/account/SigninEmail'
import SignupEmail from '@/pages/account/SignupEmail'
import Signout from '@/pages/account/Signout'
import Recover from '@/pages/account/Recover'
import SignupAgreement from '@/pages/account/SignupAgreement'
import Wageni from '@/pages/promotion/Wageni'
import { store } from '@/store'

Vue.use(Router);

const requireAuth = () => (to, from, next) => {
	if (store.getters.sessionId && store.getters.accountId) {
		next(true);
	} else {
		const encodedPath = encodeURIComponent(to.fullPath);
		next('/signin?redirect=' + encodedPath);
	}
}

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			name: 'NotFoundPage',
			component: NotFound
		},
		{
			path: '/',
			name: 'Home',
			component: Home,
			props: true
		},
		{
			path: '/kr',
			component: Redirect
		},
		{
			path: '/jp',
			component: Redirect
		},
		{
			path: '/cn',
			component: Redirect
		},
		{
			path: '/features',
			name: 'Features',
			component: Features,
			props: true
		},
		{
			path: '/educators',
			name: 'Educator',
			component: Educator
		},
		{
			path: '/curriculum',
			redirect: '/curriculum/guide',
			props: true
		},
		{
			path: '/curriculum/:menu',
			name: 'Curriculum',
			component: Curriculum,
			props: true
		},
		{
			path: '/curriculum/:menu/:submenu',
			name: 'CurriculumSubmenu',
			component: Curriculum,
			props: true
		},
		{
			path: '/help',
			redirect: '/help/faqs',
			props: true
		}, {
			path: '/help/:subject',
			name: 'Help',
			component: Help,
			props: true
		}, {
			path: '/help/:subject/:target',
			name: 'HelpDetail',
			component: Help,
			props: true
		},
		, {
			path: '/helpinapp/:subject',
			name: 'HelpApp',
			component: HelpApp,
			props: true
		}, {
			path: '/helpinapp/:subject/:target',
			name: 'HelpAppDetail',
			component: HelpApp,
			props: true
		}, {
			path: '/signin',
			name: 'Signin',
			component: Signin,
			props: true
		}, {
			path: '/signin/email',
			name: 'SigninEmail',
			component: SigninEmail,
			props: true
		}, {
			path: '/signup/email',
			name: 'SignupEmail',
			component: SignupEmail,
			props: true
		}, {
			path: '/signout',
			name: 'Signout',
			component: Signout,
			props: true
		}, {
			path: '/recover',
			name: 'Recover',
			component: Recover,
			props: true,
		}, {
			path: '/signupAgreement',
			name: 'signupAgreement',
			component: SignupAgreement,
			props: true,
		}, {
			path: '/promotion/wgn/:id',
			name: 'Wageni',
			component: Wageni,
			props: true,
			beforeEnter: requireAuth()
		}


	],
	scrollBehavior(to, from, savedPosition) {

		if (to.fullPath != from.fullPath) {
			return { x: 0, y: 0 }

		} else {
			if (savedPosition) {
				return savedPosition;

			} else {
				return { x: 0, y: 0 }
			}
		}

	}
})



// WEBPACK FOOTER //
// ./src/router/index.js